import { Button, Stack } from "@mui/material"
import { useState } from "react"
import AddRoundedIcon from "@mui/icons-material/AddRounded"
import { getAllAccounts, getAccountFilters, getAccountSort } from "../../api"
import { AuthorizedFor } from "../common/AuthorizedFor"
import roles from "../../constants/roles"
import ListData from "../common/ListData"
import AccountCard from "../cards/AccountCard"
import AddAccount from "../modals/AddAccount"
import DeleteAccount from "../modals/DeleteAccount"
import TransferBalance from "../modals/TransferBalance"

const Accounts = ({ admissionData }) => {
  const [fetchData, setFetchData] = useState(false)
  const [addAccountModal, setAddAccountModal] = useState(false)
  const [deleteAccountModal, setDeleteAccountModal] = useState(false)
  const [transferBalance, setTransferBalance] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null)

  const openTransferBalance = () => setTransferBalance(true)
  const closeTransferBalance = () => setTransferBalance(false)

  const openAddAccount = (item) => {
    setSelectedItem(item)
    setAddAccountModal(true)
  }
  const closeAddAccount = () => setAddAccountModal(false)
  const openDeleteModal = (item) => {
    setSelectedItem(item)
    setDeleteAccountModal(true)
  }
  const closeDeleteModal = () => setDeleteAccountModal(false)

  const CTA = () => (
    <AuthorizedFor roles={[roles.ADMIN, roles.STAFF]}>
      <Stack direction="row" spacing={2}>
        <Button
          onClick={openTransferBalance}
          sx={{ mx: "0.5rem" }}
          variant="contained"
        >
          Transfer Balance
        </Button>
        <Button
          onClick={() => openAddAccount(null)}
          sx={{ mx: "0.5rem" }}
          variant="contained"
          startIcon={<AddRoundedIcon />}
        >
          Add Account
        </Button>
      </Stack>
    </AuthorizedFor>
  )

  return (
    <>
      <ListData
        getFilters={getAccountFilters}
        getSort={getAccountSort}
        getAllData={getAllAccounts}
        initialFilters={{}}
        HeaderRight={CTA}
        Card={AccountCard}
        openEditCard={openAddAccount}
        openDeleteCard={openDeleteModal}
        refresh={fetchData}
        type="CARD"
      />

      <AddAccount
        isOpen={addAccountModal}
        close={closeAddAccount}
        data={selectedItem}
        refresh={() => setFetchData(!fetchData)}
      />
      <DeleteAccount
        isOpen={deleteAccountModal}
        close={closeDeleteModal}
        data={selectedItem}
        refresh={() => setFetchData(!fetchData)}
      />
      <TransferBalance isOpen={transferBalance} close={closeTransferBalance} />
    </>
  )
}

export default Accounts
